<payee-popup title="Elveti a nem mentett változtatásokat?">
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="blue"
      width="wide"
      height="normal"
      (click)="exit()"
    >
      <div class="confirm-button flex vcenter hcenter">
        <span>Elvetem</span>
        <payee-icon name="arrow-right-white" width="12px"></payee-icon>
      </div>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      [isBorderButton]="true"
      mat-dialog-close
      color="white"
      width="wide"
      height="normal"
      (click)="stay()"
    >
      <div class="cancel-button flex vcenter hcenter">
        <span>Mégsem</span>
        <payee-icon
          name="arrow-right-grey"
          width="auto"
          height="12px"
        ></payee-icon>
      </div>
    </button>
  </ng-template>
</payee-popup>
